// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableList_reportDivider__2y2wi"};